import { Modal } from '@seiue/ui'
import styled from 'styled-components'

import { Outline } from 'packages/sdks-next/growp'

import { MoveToChapterModalContent } from './MoveToChapterModalContent'

/**
 * 打开移动到其他章节弹窗
 *
 * @param param0 - 参数
 * @param param0.outlines - 课程章节
 * @param param0.taskId - 任务id
 * @param param0.defaultOutlineId - 默认选中的章节id
 */
export const openMoveToOtherChapterModal = ({
  outlines,
  taskId,
  defaultOutlineId,
}: {
  outlines: Outline[]
  taskId: number
  defaultOutlineId?: number
}) => {
  const { hide } = Modal.open({
    title: (
      <Title>
        <TitleLabel>{'移至其他章节'}</TitleLabel>
        <SubTitle>{'点击选择章节'}</SubTitle>
      </Title>
    ),
    footer: null,
    width: 480,
    bodyStyle: { padding: 0, overflow: 'hidden' },
    children: (
      <MoveToChapterModalContent
        hide={() => hide()}
        outlines={outlines}
        taskId={taskId}
        defaultOutlineId={defaultOutlineId}
      />
    ),
  })
}

const Title = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

const TitleLabel = styled.div`
  color: ${(p) => p.theme.text._1};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`

const SubTitle = styled.div`
  color: ${(p) => p.theme.text._3};
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
`
